import React, { useEffect } from "react";
import "./css/selectioncard.css";

export default function ModelSelectCard(props) {
    let tag = "BTU";
    let val = "";
    let modelname = "";
    var condn_units_count = Number(props.tool === "System" ? props.condn_units_count : 1);
    var extra_evap = (condn_units_count > 1 ? " (" + String(Number(props.count) * condn_units_count) + " Evap)" : "");

    let mitigationData = props.mitigationData || {};
    let a2lselect = props.a2lselect || {};
    let isEvaporator = props.tool === "Evaporator";
    let sys = props.tool === "System";

    if (props.tool === "System") {
        if (props.unit === "uc") {
            tag = "BTU";
            val = (Number(props.btuh) * Number(props.count) * condn_units_count).toLocaleString() + " (" + props.btuh.toLocaleString() + "X" + String(props.count * condn_units_count) + ")";
            modelname = props.model + props.selected_option + " @(" + String(Number(props.calculated_td).toFixed(2)) + ")";
        } else {
            tag = "BTU";
            val = (Number(props.btuh) * Number(props.count)).toLocaleString() + " (" + props.btuh.toLocaleString() + "X" + String(props.count) + ")";
            modelname = props.model + props.selected_option + " | Min Room Area: " + (mitigationData.data?.minRoomArea || "No Value") + " | Zone: " + (mitigationData.data?.zone || "No Value");
        }
    } else {
        tag = "BTU";
        val = (Number(props.btuh) * Number(props.count)).toLocaleString() + " (" + props.btuh.toLocaleString() + "X" + String(props.count) + ")";
        modelname = props.model + props.selected_option;
    }

    let priceErrFlag = false;
    let clickStyle = { cursor: "pointer" };
    if (String(Number(props.price)) === "NaN") {
        priceErrFlag = true;
    }

    // Auto-update amin and zone when mitigationData changes
    useEffect(() => {
        const mitigationData = props.mitigationData || {};
        const a2lselect = props.a2lselect || {};
        const mitigationIndex = props.mitigationIndex || 0;
        
        if (a2lselect && ['R-455A', 'R-454A', 'R-454C'].includes(a2lselect)) {
            if (mitigationData && mitigationData?.mitigationZoneResponses?.length > 0) {
                const aminValue = mitigationData.mitigationZoneResponses[mitigationIndex]?.minRoomArea;
                const zoneValue = mitigationData.mitigationZoneResponses[mitigationIndex]?.zone;
                
                // Update both values in a single call to prevent race conditions
                if ((aminValue !== undefined || zoneValue !== undefined) && props.updateMinAndZone && props.active === "active") {
                    props.updateMinAndZone(aminValue, zoneValue);
                }
            }
        }
    }, [props.mitigationData]);

    const updateaMinAndZone = async (e, mitigationIndex) => {
        await props.onClick(e);

        if (a2lselect && ['R-455A', 'R-454A', 'R-454C'].includes(a2lselect)) {
            if (mitigationData && mitigationData?.mitigationZoneResponses?.length > 0) {
                const aminValue = mitigationData.mitigationZoneResponses[mitigationIndex]?.minRoomArea;
                await props.updateaMin(aminValue);

                const zoneValue = mitigationData.mitigationZoneResponses[mitigationIndex]?.zone;
                await props.updatezone(zoneValue);
            }
        }
    };

    const mitigationIndex = props.mitigationIndex || 0;
    const response = mitigationData.mitigationZoneResponses?.[mitigationIndex];

    return (
        <div style={clickStyle} className={"marg card " + props.active} onClick={(e) => updateaMinAndZone(e, props.mitigationIndex)}>
            <div>
                <div className="card-body p10">
                    <div>
                        <span className="color-blue pr-1">{modelname}</span>
                    </div>
                    <div>
                        <b className="color-dblue">
                            {priceErrFlag ? (
                                <>
                                    <i style={{ color: "#b6b60d" }} className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                    <span>  {props.price} </span>
                                </>
                            ) : (
                                <>
                                    <span>${(props.price * Number(props.count) * condn_units_count).toLocaleString()} </span>
                                    <span>(${(props.price).toLocaleString()} X {props.count * condn_units_count}){extra_evap}</span>
                                </>
                            )}
                        </b>
                    </div>

                    <div>
                        {(isEvaporator || sys) &&
                            a2lselect &&
                            ['R-455A', 'R-454A', 'R-454C'].includes(a2lselect) ? (
                            response ? (
                                <div className="mitigation-info">
                                    <p className="color-blue amin">Min Area: {response.minRoomArea} ft²</p>
                                    <p className="color-blue pr-1">
                                        Mitigation Zone:{" "}
                                        <span
                                            style={{
                                                color: response.zone === "NOT ALLOWED" ? "orange" : response.zone === "N/A" ? "#debd07" : "",
                                            }}
                                        >
                                            {response.zone === "N/A" ? "Insufficient Data" : response.zone || "No Value"}
                                        </span>
                                    </p>
                                </div>
                            ) : (
                                <div className="mitigation-info">
                                    <p className="color-blue amin">Min Area: No Value</p>
                                    <p className="color-blue pr-1">Mitigation Zone: No Value</p>
                                </div>
                            )
                        ) : null}


                        {props.label !== "" && (
                            <span className="badge badge-green mt-1 mr10">
                                <span>{props.label}</span>
                            </span>
                        )}

                        <span className="badge badge-litblue mt-1">
                            <span>{tag}: {val}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
